import React from 'react';
import './catd.css';
import cartImg from "../acepts/img-bottom1.jpg";
import Loader from '../Loader/Loader';

export const cartData = [
    {id: 1, title: "Jaxon", dataTime: "02.09.2022", deck: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди", img: cartImg},
    {id: 2, title: "Jaxon", dataTime: "02.09.2022", deck: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди", img: cartImg},
    {id: 3, title: "Jaxon", dataTime: "02.09.2022", deck: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди", img: cartImg},
    {id: 4, title: "Jaxon", dataTime: "02.09.2022", deck: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди", img: cartImg},
]

function Card(props) {
    return (
        <div className='cart_news'>
            {cartData ? cartData.map(cart => (
                <div key={cart.id} className="card" data-aos="zoom-out-up">
                <img src={cart.img} className="card-img-top" alt={cart.title} />
                <div className="card-body">
                  <p className="card-text">{cart.deck}</p>
                  <hr />
                  <div className="cart_footer w-100 d-flex align-items-center justify-content-between">
                  <h4 className='text-success'>{cart.title} </h4>
                  <span> <i class="bi bi-clock me-2"></i> {cart.dataTime}</span>
                  </div>
                </div>
              </div>
            ))   
        :
        <Loader />}
        </div>
    );
}

export default Card;